/**
 * Copyright SweetCode. All rights reserved.
 *
 * Load VWO event listeners
 * */

// Pixel load event listener
jQuery(document).on("pmw:load-pixels", () => {

	if (pmwDataLayer?.pixels?.vwo?.account_id && !pmwDataLayer?.pixels?.vwo?.loaded) {
		if (pmw.consent.canPixelBeFired("statistics", "VWO")) pmw.loadVwoPixel()
	}
})

// view order received page event
jQuery(document).on("pmw:pixel:purchase", (event, payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "vwo")) return
		if (pmw.canNotFireVwoEvent()) return

		const vwoData = payload.pixels?.vwo;
		if (!vwoData) return;

		const data = [vwoData.event_type, vwoData.revenue_value];

		pmw.vwoLoaded().then(() => {
			window.VWO.push(data)
			pmw.console.log("VWO Pixel: track.revenueConversion event sent", data)
		})

	} catch (e) {
		console.error(e)
	}
})

